module.exports = __webpack_public_path__ + "img/intersect.8d67cf8c.svg";